import { useMemo } from "react";
import { AuctionEntryDirectiveObjectiveData } from "../../../../types/auctionEntry.type";
import { MaintenanceEstablishmentChoiceAuctionEntryProposalData } from "../../../../types/auctionEntryProposal.type";
import ProposalGroupHeader from "../../../CreateExecutionAuctionProposal/components/ObjectiveAttributes/ProposalGroupHeader";
import ActivityRow from "./ActivityRow";

interface AuctionProposalDetailsExecutionObjectiveActivitiesProps {
  executionObjective: AuctionEntryDirectiveObjectiveData;
  proposalDetails: MaintenanceEstablishmentChoiceAuctionEntryProposalData | undefined;
  activityStartIndex: number;
  auctionEntryUpdatedAt: number;
  proposalDetailsUpdatedAt: number;
}

const AuctionProposalDetailsExecutionObjectiveActivities = ({
  executionObjective,
  proposalDetails,
  activityStartIndex,
  auctionEntryUpdatedAt,
  proposalDetailsUpdatedAt,
}: AuctionProposalDetailsExecutionObjectiveActivitiesProps) => {
  const activitiesCountDisplay = useMemo(() => {
    const count = executionObjective.execution_activities?.length || 0;

    if (count === 0) {
      return 'Nenhum serviço';
    }

    if (count === 1) {
      return '1 Serviço';
    }

    return `${count} Serviços`;
  }, [auctionEntryUpdatedAt]);

  const totalValueSum = useMemo(() => {
    return (
      executionObjective.execution_activities?.reduce((prev, curr, index) => {
        const fieldIndex = activityStartIndex + index;
        const formActivity = proposalDetails?.proposal_content?.activity_modifications?.[fieldIndex];
        const originalUnitPrice = Number(curr.unit_price) || 0;
        const quantity = Number(curr.quantity) || 0;

        const newUnitPriceNumber = formActivity?.new_unit_price ? Number(formActivity.new_unit_price) : null;

        if (newUnitPriceNumber !== null && newUnitPriceNumber !== originalUnitPrice) {
          return prev + newUnitPriceNumber * quantity;
        }

        return prev + (Number(curr.total_value) || 0);
      }, 0) || 0
    );
  }, [auctionEntryUpdatedAt, proposalDetailsUpdatedAt, activityStartIndex]);

  return (
    <div className="flex flex-col gap-2">
      <ProposalGroupHeader
        title="Serviços"
        countDisplay={activitiesCountDisplay}
        totalValueSum={totalValueSum}
      />

      <div className="flex flex-col gap-3">
        {executionObjective.execution_activities?.map((executionActivity, index) => {
          const fieldIndex = activityStartIndex + index;
          const rawModification = proposalDetails?.proposal_content?.activity_modifications?.[fieldIndex];
          const proposalModification = rawModification ? {
            new_unit_price: rawModification.new_unit_price ? Number(rawModification.new_unit_price) : null,
            new_warranty_in_days: rawModification.new_warranty_in_days ?? null,
          } : undefined;

          return (
            <ActivityRow
              key={executionActivity.id}
              executionActivity={executionActivity}
              proposalModification={proposalModification}
            />
          );
        })}
      </div>
    </div>
  )
}

export default AuctionProposalDetailsExecutionObjectiveActivities;
